// extracted by mini-css-extract-plugin
export default {"styledText":"StyledText_styledText__gMur+"};